import React from "react";
import StudentNotifications from "./StudentNotifications";
import CompanyNotifications from "./CompanyNotifications";
import uploadBtn from "../assets/uploadBtn.svg";
import { Link } from "react-router-dom";

const Notifications = () => {
  const userRole = localStorage.getItem("userRole");
  const isOrganization = userRole === "organization";

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-30">
        <div className="px-4 sm:px-6 py-4 flex justify-between items-center">
          <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">
            Notifications
          </h1>
          
          {isOrganization && (
            <Link
              to="/dashboard/create-job"
              className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors duration-200 shadow-sm"
            >
              <img src={uploadBtn} alt="" className="w-4 h-4" />
              <span className="hidden sm:inline">Create Job</span>
              <span className="sm:hidden">Create</span>
            </Link>
          )}
        </div>
      </div>

      {/* Content Section */}
      <div className="px-4 sm:px-6 py-6">
        {userRole === "student" ? (
          <StudentNotifications />
        ) : userRole === "organization" ? (
          <CompanyNotifications />
        ) : (
          <div className="text-center py-12">
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Please log in to view notifications
            </h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default Notifications;